/**
 * Parses directives using helper functions
 */

import {
    getDirValue,
    has,
    queryAll,
    _if,
    _for,
    _class,
    _key,
    _style
} from "./directive-helper";

/**
 * The order is important, specially for :for and :if
 * @type {object}
 *
 */
const DIRECTIVES_LIST = {
    $key: _key,
    $class: _class,
    $style: _style,
    $for: _for,
    $if: _if,
};

/**
 * Parse directives
 * @param {HTMLElement} el the element
 * @param {object} customDirectives custom directives to expand functionalities
 * @return {HTMLElement}
 */
export function parseDirectives(el, customDirectives = {}) {
    const directives = { ...customDirectives, ...DIRECTIVES_LIST };

    for (const $dir in directives) {
        const directive = $dir.replace("$", "");
        const directiveList = queryAll(el, directive);

        for (let i = 0; i < directiveList.length; i++) {
            const el2 = directiveList[i];

            if (has(el2, directive)) {
                const value = getDirValue(el2, directive);
                directives[$dir](el2, value, directive);
            }
        }
    }
    return el;
}
